export type ExportFormat = "csv" | "xlsx";

export interface CatalogExportFilters {
    facetValueIds?: string[];
    collectionId?: string | number;
    term?: string;
    supplyTypes?: string[];
    supplierId?: string | number;
    supplierIds?: Array<string | number>;
    mov?: string[];
    shippingDate?: string[];
}

export const EXPORT_FORMAT_OPTIONS: { value: ExportFormat; label: string }[] = [
    { value: "xlsx", label: "Excel (.xlsx)" },
    { value: "csv", label: "CSV (.csv)" },
];

export const COMPACT_EXPORT_FORMAT_OPTIONS: {
    value: ExportFormat;
    label: string;
}[] = [
    { value: "xlsx", label: "XLSX" },
    { value: "csv", label: "CSV" },
];

export const COPY_SHARE_LINK_LABEL = "Copy link";

export const SHARE_LINK_SUCCESS =
    "Share link copied";

export const SHARE_LINK_NOT_CONFIGURED = "Share links are not configured";

export const EXPORT_DOWNLOAD_NOT_AVAILABLE = "Download is not available";

export const EXPORT_DOWNLOAD_FAILED = "Download failed";

export const SHARE_LINK_ERROR_PREFIX = "Error: ";
